import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { setNavigationRef } from './utils/navigation';
import HomePage from './components/home/HomePage';
import DriverRunsPage from './components/DriverRuns/DriverRunsPage';
import DriverRunPage from './components/DriverRuns/DriverRunPage';

import AllRunsPage from './components/Runs/AllRunsPage';
import RunPage from './components/Runs/RunPage';
import Main from './containers/Main/Main';
import DriverLocationsPage from './components/Location/DriverLocationsPage';
import SearchLocationsPage from './components/Location/SearchLocationsPage';
import ManageRegionsPage from './components/Regions/ManageRegionsPage';
import ManageTrucksPage from './components/Trucks/ManageTrucksPage';
import ManageUsersPage from './components/Users/ManageUsersPage';
import ManageUserControl from './components/Users/ManageUserControl';
import ManageBdmsPage from './components/Bdms/ManageBdmsPage';
import ManageLocationsPage from './components/Location/ManageLocationsPage';
import UserRequestToJoinPage from './components/Users/UserRequestToJoinPage';
import CallbackPage from './components/callback';
import SmsCallbackPage from './components/sms';
import LandingPage from './components/Landing';
import { BASE_URL } from './constants';
import EditClientView from './components/Clients/EditClientView';
import NewClientLocationPage from './components/Clients/NewClientLocationPage';
import EditLocationView from './components/Location/EditLocationView';
import QrLookupRunLocationPage from "./components/QR/QrLookupRunLocationPage";
import TankAssignmentPage from "./components/QR/TankAssignmentPage";
import TankManagementPage from "./components/Tanks/TankManagementPage";
import QrAssetRollout from './components/DriverRuns/QrAssetRollout';
import PasswordChange from './components/Users/PasswordChange';
import RebatesRCTIListView from './components/RebatesRCTI/RebatesRCTIListView';
import RebatesRCTICreate from './components/RebatesRCTI/RebatesRCTICreate';
import RebatesRCTIEdit from './components/RebatesRCTI/RebatesRCTIEdit';
import RebatesRCTIDetaillView from './components/RebatesRCTI/RebatesRCTIDetaillView';
import IntegrationIndexView from './components/Integrations/IntegrationIndexView';
import ClientRequestView from './components/ClientRequest/ClientRequestView';
import ClientConfirmPickUp from './components/Runs/ClientConfirmPickUp';
import ForgotPassword from './components/Users/ForgotPassword';
import UrgentCollectionRequest from './components/UrgentCollections/UrgentCollectionRequest';
import UrgentTankSwapRequest from './components/UrgentTankSwaps/UrgentTankSwapRequest';
import NewOilRequest from './components/NewOil/NewOilRequest';
import GlobalSettingsView from './components/GlobalSettings/globalSettingView';
import OilTypeControl from './components/GlobalSettings/OilTypeControl';
import UrgentDeliveryRequest from './components/UrgentDeliveries/UrgentDeliveryRequest';
import InvoiceList from './components/MYOB/InvoiceListView';
import InvoiceCreate from './components/MYOB/InvoiceCreate';
import InvoiceDetails from './components/MYOB/InvoiceDetailView';
import KioskPage from './components/Kiosk/KioskPage';
import PairConfirmPage from './components/Kiosk/PairConfirmPage';

// Component to set navigation reference for Redux compatibility
function NavigationSetter() {
    const navigate = useNavigate();
    React.useEffect(() => {
        setNavigationRef(navigate);
    }, [navigate]);
    return null;
}

export default function AppRoutes(props) {
    return (
        <BrowserRouter basename={BASE_URL}>
            <NavigationSetter />
            <Routes>
                {/* Forgot Password */}
                <Route path="/forgotPassword" element={<ForgotPassword />} />
                <Route path="/resetpassword/:token" element={<ForgotPassword />} />

                {/* Change Password */}
                <Route path="/passwordreset" element={<PasswordChange />} />
                <Route path="/pickup/confirm/:token" element={<ClientConfirmPickUp />} />

                {/* Main Layout Routes */}
                <Route path="/" element={<Main />}>
                    <Route index element={<HomePage />} />

                    {/* Driver Runs */}
                    <Route path="runs/driver" element={<DriverRunsPage />} />
                    <Route path="runs/driver/:id" element={<DriverRunPage />} />
                    <Route path="runs/driver/:id/locations/:locationId" element={<DriverRunPage />} />
                    <Route path="runs/driver/:id/locations/:locationId/:tankId" element={<DriverRunPage />} />

                    {/* Search Runs */}
                    <Route path="runs/search" element={<AllRunsPage />} />
                    <Route path="runs/search/:id" element={<RunPage />} />
                    <Route path="runs/search/:id/locations/:locationId" element={<RunPage />} />
                    <Route path="runs/search/:id/locations/:locationId/:tankId" element={<RunPage />} />
                    <Route path="runs/search/:id/locations/:locationId/qrAsset/update" element={<QrAssetRollout />} />

                    {/* Locations */}
                    <Route path="driver/locations" element={<DriverLocationsPage />} />
                    <Route path="locations/search" element={<SearchLocationsPage />} />

                    {/* Manage */}
                    <Route path="manage/regions" element={<ManageRegionsPage />} />
                    <Route path="manage/trucks" element={<ManageTrucksPage />} />
                    <Route path="manage/users" element={<ManageUsersPage />} />
                    <Route path="manage/users/:id" element={<ManageUserControl />} />
                    <Route path="manage/bdms" element={<ManageBdmsPage />} />
                    <Route path="manage/locations" element={<ManageLocationsPage />} />
                    <Route path="manage/locations/:id" element={<EditLocationView />} />
                    <Route path="manage/clients" element={<ManageLocationsPage />} />
                    <Route path="manage/clients/:id" element={<EditClientView />} />
                    <Route path="manage/new-client-location" element={<NewClientLocationPage />} />
                    <Route path="manage/tanks" element={<TankManagementPage />} />
                    <Route path="manage/tanks/:id" element={<TankManagementPage />} />
                    <Route path="manage/oil-types/:id" element={<OilTypeControl />} />

                    {/* Requests */}
                    <Route path="client-requests" element={<ClientRequestView />} />
                    <Route path="request-urgent-collection" element={<UrgentCollectionRequest />} />
                    <Route path="request-urgent-collection/:locationId" element={<UrgentCollectionRequest />} />
                    <Route path="request-oil-delivery" element={<UrgentDeliveryRequest />} />
                    <Route path="request-oil-delivery/:locationId" element={<UrgentDeliveryRequest />} />
                    <Route path="request-tank-swap" element={<UrgentTankSwapRequest />} />
                    <Route path="request-tank-swap/:locationId" element={<UrgentTankSwapRequest />} />
                    <Route path="request-new-oil" element={<NewOilRequest />} />
                    <Route path="request-new-oil/:locationId" element={<NewOilRequest />} />

                    {/* Rebates RCTI */}
                    <Route path="rebatesRCTI" element={<RebatesRCTIListView />} />
                    <Route path="rebatesRCTI/create" element={<RebatesRCTICreate />} />
                    <Route path="rebatesRCTI/:id" element={<RebatesRCTIDetaillView />} />
                    <Route path="rebatesRCTI/:id/edit" element={<RebatesRCTIEdit />} />

                    {/* MYOB */}
                    <Route path="invoice" element={<InvoiceList />} />
                    <Route path="invoice/create" element={<InvoiceCreate />} />
                    <Route path="invoice/:id" element={<InvoiceDetails />} />

                    {/* Settings & Configuration */}
                    <Route path="myob-configuration" element={<IntegrationIndexView />} />
                    <Route path="global-settings" element={<GlobalSettingsView />} />

                    {/* User Management */}
                    <Route path="newuser" element={<UserRequestToJoinPage />} />

                    {/* Truck console pairing — confirmed on the driver's own signed-in phone */}
                    <Route path="pair/:code" element={<PairConfirmPage />} />

                    {/* QR */}
                    <Route path="qr/lookuprun" element={<QrLookupRunLocationPage />} />
                    <Route path="qr/tankassignment" element={<TankAssignmentPage />} />
                </Route>

                {/* Routes outside Main layout */}
                {/* The truck console's landing screen. Outside Main because it runs with no signed-in
                    user, and Main bounces to B2C when there isn't one. */}
                <Route path="/kiosk" element={<KioskPage />} />
                <Route path="/callback" element={<CallbackPage />} />
                <Route path="/sms" element={<SmsCallbackPage />} />
                <Route path="/landing" element={<LandingPage />} />
            </Routes>
        </BrowserRouter>
    );
}
